import gql from "graphql-tag";
import {
  COMMON_PROPS_REFERENCES,
  COMMON_PROPS_REFERENCES_COMMENTS,
  COMMON_PROPS_REFERENCES_IS_CONTRIBUTIONS,
} from "./Reference";

export const SEARCH_PROJECTS = gql`
  query searchProjects($idValue: String!) {
    SearchProjects(title: $idValue) {
      id
      title
    }
  }
`;

const PROJECT_PARAMS = `
id,
    title,
    status,
    type,
    creationDate { formatted },
    lastModifiedDate { formatted },
    pendingInvitations {
      id,
      status,
      reminderDate {
        formatted
      },
      creator {
        id
      },
      invitee {
        id
        fullName
      }
    }
    invitations {
      id
    }
    members {
        id,
        accountId,
        fullName,
        keyName,
        abbreviatedName,
        description,
        emailAddress,
        authStatus,
        creationDate {
          formatted
        },
        imageDepictions {
          id,
          title,
          type,
          thumbnail {
            id,
            file {
              uri
            }
          }
        }
        invitationsReceived {
          id
          creator {
            id
          }
        }
      }
      owners {
        ...on Person {
          id,
          accountId,
          fullName,
          keyName,
          abbreviatedName,
          description,
          emailAddress,
          authStatus,
          imageDepictions {
            id,
            title,
            type,
            thumbnail {
              id,
              file {
                uri
                }
              }
            }
        }
      }
    `;

export const GET_PROJECT = gql`
query getProject(
    $personId: ID!,
    $projectId: ID!,
  ) {
  Project(
    personId: $personId,
    projectId: $projectId,
  ) {
    ${PROJECT_PARAMS}
  }
}
`;

export const GET_PROJECTS_LIVESTREAMS = gql`
  query getProjectsReferences($personId: ID!, $projectId: ID!) {
    Project(personId: $personId, projectId: $projectId) {
      id
      title
      liveStreams {
        id
        url
        creationDate {
          formatted
        }
        lastModifiedDate {
          formatted
        }
        isContributionOf {
          id
          contributor {
            id
            accountId
            authStatus
            fullName
            imageDepictions {
              id
              title
              type
              thumbnail {
                id
                file {
                  uri
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_PROJECTS_REFERENCES = gql`
  query getProjectsReferences($personId: ID!, $projectId: ID!) {
    Project(personId: $personId, projectId: $projectId) {
      id
      title
      references {
        ${COMMON_PROPS_REFERENCES}
        ${COMMON_PROPS_REFERENCES_COMMENTS}
        ${COMMON_PROPS_REFERENCES_IS_CONTRIBUTIONS}
      }
    }
  }
`;

export const GET_ALL_PROJECTS_OWNED_BY_PERSON = gql`
  query getProjectsOwnedByPerson($personId: ID!) {
    Person(id: $personId) {
      id
      fullName
      projects: assets {
        ... on Project {
          id
          title
          status
          type
          creationDate {
            formatted
          }
        }
      }
    }
  }
`;

export const GET_ALL_PROJECTS_BY_OWNER_OR_MEMBER_ID = gql`
  query getAllProjectsForPerson($personId: ID!) {
    PersonById(personId: $personId) {
      id
      fullName
      projectsMembership {
        ... on Project {
          id
          title
          status
          type
          creationDate {
            formatted
          }
          lastModifiedDate {
            formatted
          }
          liveStreams {
            id
            url
            creationDate {
              formatted
            }
          }
          components {
            componentId
          }
        }
      }
      projectsOwned: assets {
        ... on Project {
          id
          title
          status
          type
          creationDate {
            formatted
          }
          lastModifiedDate {
            formatted
          }
          liveStreams {
            id
            url
            creationDate {
              formatted
            }
          }
          components {
            componentId
          }
        }
      }
    }
  }
`;

export const CREATE_PROJECT = gql`
  mutation createProject(
    $id: ID,
    $title: String,
    $status: String,
    $type: String,
    $creationDate: _Neo4jDateTimeInput
  ) {
  CreateProject(
    id: $id,
    title: $title,
    status: $status,
    type: $type,
    creationDate: $creationDate
  ) {
    ${PROJECT_PARAMS}
  }
}
`;

export const CREATE_PROJECT_WITH_OWNERS = gql`
  mutation createProjectWithOwners(
    $projectId: String!
    $title: String!
    $status: String
    $partyId: ID!
  ) {
    CreateProjectWithOwners(
      projectId: $projectId
      title: $title
      status: $status
      partyId: $partyId
    ) {
      id
      title
      status
      type
      creationDate {
        formatted
      }
      lastModifiedDate {
        formatted
      }
      pendingInvitations {
        id
        status
        reminderDate {
          formatted
        }
        creator {
          id
        }
        invitee {
          id
          fullName
        }
      }
      invitations {
        id
      }
      members {
        id
        accountId
        fullName
        keyName
        abbreviatedName
        description
        emailAddress
        authStatus
        creationDate {
          formatted
        }
        imageDepictions {
          id
          title
          type
          thumbnail {
            id
            file {
              uri
            }
          }
        }
        invitationsReceived {
          id
          creator {
            id
          }
        }
      }
      owners {
        ... on Person {
          id
          accountId
          fullName
          keyName
          abbreviatedName
          description
          emailAddress
          authStatus
          imageDepictions {
            id
            title
            type
            thumbnail {
              id
              file {
                uri
              }
            }
          }
        }
      }
      resources {
        ... on Component {
          id
          title
        }
        __typename
      }
      comments {
        id
        text
        creationDate {
          formatted
        }
        author {
          id
          accountId
          fullName
          __typename
        }
      }
      genres {
        id
        name
      }
    }
  }
`;

export const UPDATE_PROJECT = gql`
  mutation updateProject(
    $personId: ID!,
    $input: ProjectInput
  ) {
    UpdateProject(
      personId: $personId,
      input: $input
  ) {
    ${PROJECT_PARAMS}
  }
}
`;

export const DELETE_PROJECT = gql`
  mutation deleteProject($personId: ID!, $projectId: ID!) {
    DeleteProject(personId: $personId, projectId: $projectId) {
      id
    }
  }
`;

export const ADD_PROJECT_CONTRIBUTIONS = gql`
  mutation addProjectContributions(
    $from: _ContributionInput!
    $to: _ProjectInput!
  ) {
    AddProjectContributions(from: $from, to: $to) {
      from {
        id
      }
      to {
        id
      }
    }
  }
`;

export const REMOVE_PROJECT_CONTRIBUTIONS = gql`
  mutation removeProjectContributions(
    $from: _ContributionInput!
    $to: _ProjectInput!
  ) {
    RemoveProjectContributions(from: $from, to: $to) {
      from {
        id
      }
      to {
        id
      }
    }
  }
`;

export const ADD_PROJECT_OWNERS = gql`
  mutation addProjectOwners($partyId: ID!, $projectId: ID!) {
    AddProjectOwners(partyId: $partyId, projectId: $projectId) {
      id
    }
  }
`;

export const REMOVE_PROJECT_OWNERS = gql`
  mutation removeProjectOwners($partyId: ID!, $projectId: ID!) {
    RemoveProjectOwners(partyId: $partyId, projectId: $projectId) {
      id
    }
  }
`;

export const GET_PROJECT_OWNERS_AND_MEMBERS = gql`
  query getProjectOwnersAndMembers($personId: ID!, $projectId: ID!) {
    Project(personId: $personId, projectId: $projectId) {
      members {
        id
        fullName
        keyName
        abbreviatedName
        description
        creationDate {
          formatted
        }
        authStatus
        imageDepictions {
          id
          url
          height
          width
        }
      }
      owners {
        ... on Person {
          id
          fullName
          keyName
          abbreviatedName
          description
          imageDepictions {
            id
            url
            height
            width
          }
        }
      }
    }
  }
`;

export const ADD_PROJECT_MEMBERS = gql`
  mutation addProjectMembers(
    $projectId: ID!
    $creatorId: ID!
    $personIds: [String]!
    $authStatus: String!
    $inviteStatus: String!
  ) {
    AddProjectMembers(
      projectId: $projectId
      creatorId: $creatorId
      personIds: $personIds
      authStatus: $authStatus
      inviteStatus: $inviteStatus
    ) {
      id
      fullName
      keyName
      abbreviatedName
      description
      imageDepictions {
        id
        url
        height
        width
      }
    }
  }
`;

export const ADD_PROJECT_MEMBERS_WITH_SHARED_COMPONENT = gql`
  mutation AddMemberWithSharedComponent(
    $projectId: ID!
    $creatorId: ID!
    $personIds: [String]!
    $authStatus: String!
    $inviteStatus: String!
    $invitationId: String!
    $invitationMessage: String
    $componentId: ID!
  ) {
    AddMemberWithSharedComponent(
      projectId: $projectId
      creatorId: $creatorId
      personIds: $personIds
      authStatus: $authStatus
      inviteStatus: $inviteStatus
      invitationId: $invitationId
      invitationMessage: $invitationMessage
      componentId: $componentId
    ) {
      id
      invitee {
        id
        emailAddress
        fullName
        authStatus
      }
    }
  }
`;

export const HAS_PROJECT_MEMBER_CONTRIBUTED = gql`
  query hasMemberDoneWorkInProject(
    $personId: ID!
    $projectId: ID!
    $statusToAvoid: String!
  ) {
    HasMemberDoneWorkInProject(
      personId: $personId
      projectId: $projectId
      statusToAvoid: $statusToAvoid
    )
  }
`;

export const REMOVE_PROJECT_MEMBER = gql`
  mutation removeProjectMember(
    $personId: ID!
    $projectId: ID!
    $taskStatus: String!
  ) {
    RemoveProjectMember(
      personId: $personId
      projectId: $projectId
      taskStatus: $taskStatus
    ) {
      id
    }
  }
`;

export const SOFT_REMOVE_SELF_FROM_PROJECT = gql`
  mutation softRemoveSelfFromProject($personId: ID!, $projectId: ID!) {
    SoftRemoveSelfFromProject(personId: $personId, projectId: $projectId) {
      id
    }
  }
`;

export const HARD_REMOVE_SELF_FROM_PROJECT = gql`
  mutation hardRemoveSelfFromProject($personId: ID!, $projectId: ID!) {
    HardRemoveSelfFromProject(personId: $personId, projectId: $projectId) {
      id
    }
  }
`;

export const SEARCH_FOR_PROJECT_OWNERS_OR_MEMBERS = gql`
  query filterProjectMembersAndOwners(
    $personId: ID!
    $projectId: ID!
    $searchPhrase: String!
  ) {
    Project(personId: $personId, projectId: $projectId) {
      membersFilter(searchPhrase: $searchPhrase) {
        id
        fullName
        emailAddress
        authStatus
        imageDepictions {
          file {
            uri
          }
        }
      }
      ownersFilter(searchPhrase: $searchPhrase) {
        id
        fullName
        emailAddress
        imageDepictions {
          file {
            uri
          }
        }
      }
    }
  }
`;

// AddProjectGenres(
//   from: _GenreInput!
//   to: _ProjectInput!
// ): _AddProjectGenresPayload
// RemoveProjectGenres(
//   from: _GenreInput!
//   to: _ProjectInput!
// ): _RemoveProjectGenresPayload
// AddProjectComments(
//   from: _CommentInput!
//   to: _ProjectInput!
// ): _AddProjectCommentsPayload
// RemoveProjectComments(
//   from: _CommentInput!
//   to: _ProjectInput!
// ): _RemoveProjectCommentsPayload
// AddProjectRequires(
//   from: _ProjectInput!
//   to: _ContributionInput!
// ): _AddProjectRequiresPayload
// RemoveProjectRequires(
//   from: _ProjectInput!
//   to: _ContributionInput!
// ): _RemoveProjectRequiresPayload
